import type { MigrationStrategies } from 'rxdb';
import type { SignAndStampUserLevelDocument } from './signAndStampUserLevel.types';

export const signAndStampUserLevelMigrationStrategies: MigrationStrategies = {
  1: (oldDoc: SignAndStampUserLevelDocument) => {
    const newDoc = {
      ...oldDoc,
    };
    delete newDoc.inspectorId;
    return newDoc;
  },
};
